import { useTheme } from "@emotion/react";
import {
  Add,
  DeleteOutlined,
  EditOutlined,
  ManageAccountsOutlined,
  SellOutlined,
  SupportAgentOutlined,
} from "@mui/icons-material";
import {
  alpha,
  Box,
  Button,
  Chip,
  IconButton,
  List,
  MenuItem,
  Paper,
  Popper,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import api from "../../../src/services/api";
import useStyles from "./styles";
import InternoModalConfirmacaoSaida from "../modalSaindoDaPagina";
import { set } from "react-hook-form";
const MentionTextField = ({
  typeMetion = "ticket",
  value = "",
  onChange,

  titlePopper = "Roteiro de Atendimento",
  ...textFieldProps
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [openAddScript, setOpenAddScript] = useState(false);
  const [openEditScript, setOpenEditScript] = useState(false);
  const [roteiros, setRoteiros] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [dataRoteiro, setDataRoteiro] = useState({
    title: "",
    description: "",
  });
  const theme = useTheme();
  const styles = useStyles(theme);

  const filteredScripts = useMemo(() => {
    return roteiros?.filter((s) =>
      s?.title?.toLowerCase()?.includes(filterText?.toLowerCase()),
    );
  }, [roteiros, filterText]);
  const listRef = useRef(null);
  useEffect(() => {
    if (anchorEl && listRef.current) {
      // Busca o item que tem o atributo "selected" ou usa o índice
      const selectedItem = listRef.current.querySelector(
        `[data-index="${selectedIndex}"]`,
      );

      if (selectedItem) {
        selectedItem.scrollIntoView({
          block: "nearest", // Rola o mínimo necessário para aparecer
          behavior: "smooth", // Opcional: deixa a transição suave
        });
      }
    } else {
      setOpenAddScript(false);
    }
  }, [selectedIndex, anchorEl]);

  useEffect(() => {
    getRoteiros();
  }, []);

  const configStylesMetion = {
    ticket: {
      // Agora é uma função que aceita isPublic
      iconPopper: (isPublic) => (
        <SellOutlined
          sx={{
            ...styles.iconPopper,
            color: isPublic
              ? theme.palette.colors.orange.medium
              : theme.palette.primary.main,
          }}
        />
      ),
      iconTitle: <SupportAgentOutlined sx={styles.iconTitle} />,
    },
    os: {
      // Agora é uma função que aceita isPublic
      iconPopper: (isPublic) => (
        <ManageAccountsOutlined
          sx={{
            ...styles.iconPopper,
            color: isPublic
              ? theme.palette.colors.orange.medium
              : theme.palette.primary.main,
          }}
        />
      ),
      iconTitle: <SupportAgentOutlined sx={styles.iconTitleoS} />,
    },
  };

  const getRoteiros = async () => {
    try {
      const response = await api.post("/interno/find/roteiros", {
        typeRoteiro: typeMetion,
      });

      setRoteiros(response?.data);
    } catch (err) {
      console.log(err);
    } finally {
    }
  };
  const createRoteiro = async () => {
    setLoading(true);
    if (
      dataRoteiro?.title?.trim() === "" ||
      dataRoteiro?.description?.trim() === ""
    ) {
      setError(true);
      return;
    }
    setError(false);
    try {
      const response = await api.post("/create/roteiro", {
        title: dataRoteiro.title,
        description: dataRoteiro.description,
        typeRoteiro: typeMetion,
      });
      setRoteiros((prev) => [...prev, response.data]);
    } catch (error) {
      console.error("Erro ao criar roteiro:", error);
    } finally {
      handleCloseAddScript();
      setLoading(false);
    }
  };

  const editRoteiro = async () => {
    setLoading(true);
    try {
      const response = await api.post("/interno/edit/roteiros", {
        data: {
          title: dataRoteiro.title,
          description: dataRoteiro.description,
        },
        idRoteiro: dataRoteiro?.id,
      });

      setRoteiros((prev) =>
        prev.map((roteiro) =>
          roteiro?.id === response?.data?.id ? response?.data : roteiro,
        ),
      );
    } catch (err) {
      console.log(err);
    } finally {
      handleCloseAddScript();
      setLoading(false);
    }
  };

  const deleteRoteiro = async () => {
    setLoading(true);
    try {
      const response = await api.post("/interno/delete/roteiros", {
        idRoteiro: dataRoteiro?.id,
      });
      setRoteiros((prev) =>
        prev?.filter((roteiro) => roteiro?.id !== dataRoteiro?.id),
      );
    } catch (err) {
      console.log(err);
    } finally {
      handleCloseAddScript();
      setLoading(false);
    }
  };

  const handleSelectScript = (description) => {
    const parts = value.split("@");
    parts.pop();
    const newValue = parts.join("@") + description;
    handleCloseAddScript();

    onChange(newValue);
    setAnchorEl(null);
  };

  const handleKeyDown = (e) => {
    if (anchorEl && filteredScripts?.length > 0) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev + 1) % filteredScripts?.length);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex(
          (prev) =>
            (prev - 1 + filteredScripts?.length) % filteredScripts?.length,
        );
      } else if (e.key === "Enter" || e.key === "Tab") {
        e.preventDefault();
        handleSelectScript(filteredScripts[selectedIndex].description);
      } else if (e.key === "Escape") {
        setAnchorEl(null);
      }
    }

    textFieldProps.onKeyDown?.(e);
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    const cursorPosition = event.target.selectionStart;
    const textBeforeCursor = newValue.substring(0, cursorPosition);

    const words = textBeforeCursor.split(/\s/);
    const lastWord = words[words.length - 1];

    if (lastWord.startsWith("@")) {
      const textarea = event.target;
      // cursorPosition já foi pego lá em cima, não precisa declarar de novo

      // Calculamos as coordenadas relativas ao scroll interno do textarea
      const { top: caretTop, left: caretLeft } = getCaretCoordinates(
        textarea,
        cursorPosition,
      );

      const virtualElement = {
        getBoundingClientRect: () => {
          // Pegamos o rect atualizado toda vez que o Popper precisar se reposicionar
          const rect = textarea.getBoundingClientRect();
          const x = rect.left + caretLeft;
          const y = rect.top + caretTop - textarea.scrollTop;

          return {
            width: 0,
            height: 0,
            top: y,
            left: x,
            right: x,
            bottom: y,
          };
        },
        // --- ADICIONE ESTAS DUAS LINHAS ---
        nodeType: 1, // Simula um nó DOM válido para evitar erros no Popper
        contextElement: textarea, // Diz ao Popper qual elemento seguir no scroll!
        // ----------------------------------
      };

      setAnchorEl(virtualElement);
      setFilterText(lastWord?.substring(1));
      setSelectedIndex(0);
    } else {
      setAnchorEl(null);
    }

    onChange(newValue);
    textFieldProps.onChange?.(event);
  };

  const getCaretCoordinates = (textarea, position) => {
    const div = document.createElement("div");
    const style = window.getComputedStyle(textarea);

    for (let i = 0; i < style.length; i++) {
      const prop = style[i];
      div.style[prop] = style.getPropertyValue(prop);
    }

    div.style.position = "absolute";
    div.style.visibility = "hidden";
    div.style.whiteSpace = "pre-wrap";
    div.style.wordWrap = "break-word";

    div.textContent = textarea.value.substring(0, position);

    const span = document.createElement("span");
    span.textContent = textarea.value.substring(position) || ".";
    div.appendChild(span);

    document.body.appendChild(div);

    const { offsetTop, offsetLeft } = span;

    document.body.removeChild(div);

    return {
      top: offsetTop,
      left: offsetLeft,
    };
  };

  const handleAddScript = () => {
    setOpenAddScript(true);
  };

  const handleCloseAddScript = () => {
    setOpenAddScript(false);
    setOpenEditScript(false);
    setError(false);
    setOpenDeleteConfirm(false);
    setDataRoteiro({
      title: "",
      description: "",
    });
  };

  return (
    <>
      <TextField
        {...textFieldProps}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      {openAddScript || openEditScript ? (
        <Popper
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          placement="bottom-start"
          style={styles.popper}
          disablePortal
        >
          <Paper sx={styles.paperPopper}>
            <Box sx={styles.boxTitlePopper}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <SupportAgentOutlined sx={styles.iconTitle} />
                <Typography
                  sx={styles.titlePopper}
                  variant="caption"
                  fontWeight="bold"
                >
                  {openAddScript
                    ? "Criar novo roteiro"
                    : openEditScript
                      ? "Editar roteiro"
                      : ""}
                </Typography>
              </Box>
            </Box>
            <Box sx={styles.containerHandleScript}>
              <Box sx={styles.containerTextField}>
                <TextField
                  size="small"
                  variant="filled"
                  autoComplete="off"
                  label="Título do roteiro"
                  sx={{ width: "100%" }}
                  value={dataRoteiro?.title}
                  error={error && dataRoteiro?.title?.trim() === ""}
                  helperText={
                    error &&
                    dataRoteiro?.title?.trim() === "" &&
                    "Campo obrigatório"
                  }
                  onChange={(e) => {
                    setDataRoteiro((prev) => ({
                      ...prev,
                      title: e.target.value,
                    }));
                  }}
                />
                <TextField
                  size="small"
                  multiline
                  minRows={6}
                  maxRows={6}
                  autoComplete="off"
                  value={dataRoteiro?.description}
                  label="Descrição do roteiro"
                  variant="filled"
                  sx={{ width: "100%" }}
                  error={error && dataRoteiro?.description?.trim() === ""}
                  helperText={
                    error &&
                    dataRoteiro?.description?.trim() === "" &&
                    "Campo obrigatório"
                  }
                  onChange={(e) => {
                    setDataRoteiro((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }));
                  }}
                />
              </Box>
              <Box sx={styles.containerActions}>
                <Button
                  disabled={loading}
                  variant="outlined"
                  onClick={() => handleCloseAddScript()}
                >
                  Cancelar
                </Button>
                <Button
                  disabled={loading}
                  onClick={() =>
                    openAddScript
                      ? createRoteiro()
                      : openEditScript
                        ? editRoteiro()
                        : null
                  }
                  variant="contained"
                >
                  Salvar
                </Button>
              </Box>
            </Box>
          </Paper>
        </Popper>
      ) : (
        <Popper
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          placement="bottom-start"
          style={styles.popper}
          disablePortal
        >
          <Paper sx={{ ...styles.paperPopper, overflowX: "hidden" }}>
            <Box sx={styles.boxTitlePopper}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  minWidth: 0,
                }}
              >
                {configStylesMetion[typeMetion]?.iconTitle}
                <Typography
                  sx={{
                    ...styles.titlePopper,
                  }}
                  variant="caption"
                  fontWeight="bold"
                >
                  {titlePopper}
                </Typography>
              </Box>
              <Button
                sx={{ height: 30, flexShrink: 0 }} // flexShrink: 0 impede o botão de esmagar
                variant="outlined"
                endIcon={<Add />}
                size="small"
                onClick={handleAddScript}
              >
                Criar
              </Button>
            </Box>

            <List ref={listRef} sx={styles.listPopper}>
              {filteredScripts?.length > 0 ? (
                filteredScripts?.map((item, index) => (
                  <MenuItem
                    key={index}
                    data-index={index}
                    selected={index === selectedIndex}
                    onClick={() => handleSelectScript(item?.description)}
                    sx={{ ...styles.menuItem, width: "100%" }}
                  >
                    <Box sx={styles.boxMenuItem}>
                      <Box
                        sx={{ display: "flex", gap: 1.5, minWidth: 0, flex: 1 }}
                      >
                        <Box sx={{ ...styles.boxIcon, flexShrink: 0 }}>
                          {configStylesMetion[typeMetion]?.iconPopper(
                            item?.public,
                          )}
                        </Box>

                        <Box sx={{ minWidth: 0, flex: 1 }}>
                          <Typography variant="body2" sx={styles.title}>
                            {item?.title}
                          </Typography>

                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={styles.description}
                          >
                            {item?.description?.replace(/\n/g, " ")}
                          </Typography>
                        </Box>
                      </Box>
                      {item?.public ? (
                        <Chip label="Gestão" sx={styles.chip} />
                      ) : (
                        <Box sx={{ display: "flex", flexShrink: 0 }}>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              setDataRoteiro({
                                title: item.title,
                                description: item.description,
                                id: item.id,
                              });
                              setOpenEditScript(true);
                            }}
                          >
                            <EditOutlined sx={{ fontSize: 18 }} />
                          </IconButton>
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              setDataRoteiro({
                                title: item.title,
                                description: item.description,
                                id: item.id,
                              });
                              setOpenDeleteConfirm(true);
                            }}
                            size="small"
                          >
                            <DeleteOutlined
                              color="error"
                              sx={{ fontSize: 18 }}
                            />
                          </IconButton>
                        </Box>
                      )}
                    </Box>
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>Nenhum roteiro encontrado</MenuItem>
              )}
            </List>
          </Paper>
        </Popper>
      )}
      <InternoModalConfirmacaoSaida
        openConfirmacao={openDeleteConfirm}
        deleteLoad={loading}
        setOpenConfirmacao={setOpenDeleteConfirm}
        execute={deleteRoteiro}
        severity={"error"}
        title={"Atenção"}
        contentText={
          "Se você prosseguir com a operação, o roteiro será deletado permanentemente!"
        }
        confirmText={"Excluir"}
      />
    </>
  );
};

export default MentionTextField;
